// extracted by mini-css-extract-plugin
export default {"container":"PageLink_container__zEY+U","icon":"PageLink_icon__X-de9"};